"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusWrapper = exports.TripStatus = exports.TabButton = exports.TabsControl = exports.Tab = exports.TabsWrapper = exports.TagsWrapper = exports.ExtraDataWrapper = exports.LocationDatetime = exports.LocationSubWrapper = exports.LocationWrapper = exports.ArrowWrapper = exports.LogosWrapper = exports.InfoWrapper = exports.FolioOption = exports.FolioTitle = exports.ETACardlow = exports.ETAlow = exports.ETACardlate = exports.ETAlate = exports.ETACardDescription = exports.ETADescription = exports.ETAWrapper = exports.FolioOptionsWrapper = exports.FolioWrapper = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__Wrapper",
  componentId: "xocimy-0"
})(["width:100%;position:relative;"]);

exports.Wrapper = Wrapper;

var FolioWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__FolioWrapper",
  componentId: "xocimy-1"
})(["display:flex;flex-direction:column;padding:0 1.2rem;"]);

exports.FolioWrapper = FolioWrapper;

var FolioOptionsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__FolioOptionsWrapper",
  componentId: "xocimy-2"
})(["display:flex;flex-direction:row;margin-bottom:1rem;width:400px;overflow:auto;"]);

exports.FolioOptionsWrapper = FolioOptionsWrapper;

var ETAWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__ETAWrapper",
  componentId: "xocimy-3"
})(["display:flex;flex-direction:row;"]);

exports.ETAWrapper = ETAWrapper;

var ETADescription = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__ETADescription",
  componentId: "xocimy-4"
})(["color:white;margin-right:5px;"]);

exports.ETADescription = ETADescription;

var ETACardDescription = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__ETACardDescription",
  componentId: "xocimy-5"
})(["color:black;margin-right:3px;font-size:6px;"]);

exports.ETACardDescription = ETACardDescription;

var ETAlate = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__ETAlate",
  componentId: "xocimy-6"
})(["color:red;"]);

exports.ETAlate = ETAlate;

var ETACardlate = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__ETACardlate",
  componentId: "xocimy-7"
})(["color:red;font-size:7px;"]);

exports.ETACardlate = ETACardlate;

var ETAlow = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__ETAlow",
  componentId: "xocimy-8"
})(["color:white;"]);

exports.ETAlow = ETAlow;

var ETACardlow = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__ETACardlow",
  componentId: "xocimy-9"
})(["color:black;font-size:7px;"]);

exports.ETACardlow = ETACardlow;

var FolioTitle = _styledComponents["default"].span.withConfig({
  displayName: "ShipmentTicketDetailStyles__FolioTitle",
  componentId: "xocimy-10"
})(["font-size:0.9rem;"]);

exports.FolioTitle = FolioTitle;

var FolioOption = _styledComponents["default"].span.withConfig({
  displayName: "ShipmentTicketDetailStyles__FolioOption",
  componentId: "xocimy-11"
})(["border-bottom:", ";margin-right:1rem;cursor:pointer;"], function (props) {
  return props.isActive ? '3px solid #387ef8' : '0';
});

exports.FolioOption = FolioOption;

var InfoWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__InfoWrapper",
  componentId: "xocimy-12"
})(["display:flex;flex-direction:column;padding:0 1.2rem 0 1.2rem;position:relative;"]);

exports.InfoWrapper = InfoWrapper;

var LogosWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__LogosWrapper",
  componentId: "xocimy-13"
})(["display:flex;flex-direction:row;justify-content:space-around;width:100%;margin-top:0.4rem;"]);

exports.LogosWrapper = LogosWrapper;

var ArrowWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__ArrowWrapper",
  componentId: "xocimy-14"
})([""]);

exports.ArrowWrapper = ArrowWrapper;

var LocationWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__LocationWrapper",
  componentId: "xocimy-15"
})(["display:flex;flex-direction:row;margin-top:0.4rem;justify-content:space-around;"]);

exports.LocationWrapper = LocationWrapper;

var LocationSubWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__LocationSubWrapper",
  componentId: "xocimy-16"
})(["display:flex;flex-direction:column;justify-content:flex-start;border:", ";padding:0 10px;border-radius:5px;max-width:100px;overflow-x:scroll;"], function (props) {
  return props.border || '';
}); // export const LocationTitle = styled.span``;


exports.LocationSubWrapper = LocationSubWrapper;

var LocationDatetime = _styledComponents["default"].span.withConfig({
  displayName: "ShipmentTicketDetailStyles__LocationDatetime",
  componentId: "xocimy-17"
})([""]);

exports.LocationDatetime = LocationDatetime;

var ExtraDataWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__ExtraDataWrapper",
  componentId: "xocimy-18"
})(["display:flex;flex-direction:row;justify-content:center;margin-top:1rem;"]);

exports.ExtraDataWrapper = ExtraDataWrapper;

var TagsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__TagsWrapper",
  componentId: "xocimy-19"
})(["background:#dfe5ea;padding:1rem 0;display:flex;flex-direction:row;justify-content:center;margin-top:1rem;"]);

exports.TagsWrapper = TagsWrapper;

var TabsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__TabsWrapper",
  componentId: "xocimy-20"
})(["display:flex;flex-direction:row;overflow-x:hidden;width:30rem;"]);

exports.TabsWrapper = TabsWrapper;

var Tab = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__Tab",
  componentId: "xocimy-21"
})(["min-width:30rem;"]);

exports.Tab = Tab;

var TabsControl = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__TabsControl",
  componentId: "xocimy-22"
})(["display:flex;flex-direction:row;justify-content:center;align-items:center;"]);

exports.TabsControl = TabsControl;

var TabButton = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__TabButton",
  componentId: "xocimy-23"
})(["background-color:", ";width:12px;height:12px;border-radius:12px;cursor:pointer;margin:5px;"], function (props) {
  return props.isActive ? 'rgb(75, 116, 242)' : 'rgb(196, 196, 196)';
});

exports.TabButton = TabButton;

var TripStatus = _styledComponents["default"].span.withConfig({
  displayName: "ShipmentTicketDetailStyles__TripStatus",
  componentId: "xocimy-24"
})(["color:#4f5d77;font-size:0.8rem;"]);

exports.TripStatus = TripStatus;

var StatusWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentTicketDetailStyles__StatusWrapper",
  componentId: "xocimy-25"
})(["background:#dfe5ea;padding:0.5rem 0;display:flex;flex-direction:row;justify-content:center;margin-top:1rem;"]);

exports.StatusWrapper = StatusWrapper;